import React from 'react';
import TeaserProduct from './TeaserProduct';
import TeaserNode from './TeaserNode';

export default function SearchResult(props) {
    return (
      <TeaserNode hit={props.hit}/>
    )
}
